import React from 'react'
import { Box, Chip } from '@mui/material'
import { TooltipSeeker } from '@ui-seeker/core'
import { NotAllowedBlock } from '@components'

export default function SampleCell({ sample = [], total = 0 }) {
    return (
        <Box display="flex" flexWrap="wrap" justifyContent="center" gap={0.5} sx={{ py: 0.5 }}>
            {!sample?.length && <NotAllowedBlock />}
            {sample.map((name, i) => (
                <TooltipSeeker key={i} title={name}>
                    <Chip
                        label={name}
                        size="small"
                        sx={{ maxWidth: 200, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }}
                    />
                </TooltipSeeker>
            ))}
            {total > sample.length && (
                <Chip
                    label={`+${total - sample.length}`}
                    size="small"
                    color="primary"
                    sx={{ fontWeight: 700 }}
                />
            )}
        </Box>
    )
}
